// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-info-container {
  background: var(--v-info-background, var(--gc-color-light-tint));
  border: solid var(--v-info-border, var(--gc-border-color));
  border-width: 1px 1px 1px 6px;
  display: grid;
  grid-template-columns: [severity-start] auto [severity-end content-start] 1fr [content-end close-start] auto [close-end];
  padding: 0.75rem 1rem;
}

.severity {
  grid-column: severity;
  margin-right: 0.5rem;
}

.content {
  grid-column: content;
}

.close-button {
  grid-column: close;
  margin-right: -0.5rem;
  margin-top: -0.25rem;
}

v-icon.severity {
  color: var(--v-info-border, --gc-text-color);
}

:host.error, :host.danger {
  --v-info-background: var(--gc-error-background);
  --v-info-border: var(--gc-error-border);
}
:host.warn {
  --v-info-background: rgba(var(--gc-color-warning-rgb), 0.2);
  --v-info-border: var(--gc-color-warning-shade);
}
:host.success {
  --v-info-background: rgba(var(--gc-color-success-rgb), 0.2);
  --v-info-border: var(--gc-color-success-tint);
}
:host.info {
  --v-info-background: rgba(var(--gc-color-info-rgb), 0.2);
  --v-info-border: var(--gc-color-info-shade);
}

:host:empty {
  display: none;
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-info/v-info.component.sass"],"names":[],"mappings":"AAAA;EACI,gEAAA;EACA,0DAAA;EACA,6BAAA;EAEA,aAAA;EACA,wHAAA;EACA,qBAAA;AAAJ;;AAEA;EACI,qBAAA;EACA,oBAAA;AACJ;;AAAA;EACI,oBAAA;AAGJ;;AAFA;EACI,kBAAA;EACA,qBAAA;EACA,oBAAA;AAKJ;;AAHA;EACI,4CAAA;AAMJ;;AAHI;EACI,+CAAA;EACA,uCAAA;AAMR;AALI;EACI,2DAAA;EACA,8CAAA;AAOR;AANI;EACI,2DAAA;EACA,6CAAA;AAQR;AAPI;EACI,wDAAA;EACA,2CAAA;AASR;;AAPA;EACI,aAAA;EACA,kBAAA;AAUJ","sourcesContent":[".v-info-container\n    background: var(--v-info-background, var(--gc-color-light-tint))\n    border: solid var(--v-info-border, var(--gc-border-color))\n    border-width: 1px 1px 1px 6px\n    \n    display: grid\n    grid-template-columns: [severity-start] auto [severity-end content-start] 1fr [content-end close-start] auto [close-end]\n    padding: 0.75rem 1rem\n\n.severity\n    grid-column: severity\n    margin-right: 0.5rem\n.content\n    grid-column: content\n.close-button\n    grid-column: close\n    margin-right: -0.5rem\n    margin-top: -0.25rem\n\nv-icon.severity\n    color: var(--v-info-border, --gc-text-color)\n    \n:host \n    &.error, &.danger\n        --v-info-background: var(--gc-error-background)\n        --v-info-border: var(--gc-error-border)\n    &.warn\n        --v-info-background: rgba(var(--gc-color-warning-rgb), 0.2)\n        --v-info-border: var(--gc-color-warning-shade)\n    &.success\n        --v-info-background: rgba(var(--gc-color-success-rgb), 0.2)\n        --v-info-border: var(--gc-color-success-tint)\n    &.info\n        --v-info-background: rgba(var(--gc-color-info-rgb), 0.2)\n        --v-info-border: var(--gc-color-info-shade)\n\n:host:empty\n    display: none\n    visibility: hidden"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
